import React from 'react';
import {BaseIcon, iconDefaultProps, iconPropTypes} from './base-icon';
export const HelpIcon = ({...props}) => (
	<BaseIcon {...props}>
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 20.8C16.8601 20.8 20.8 16.8601 20.8 12C20.8 7.13989 16.8601 3.2 12 3.2C7.13989 3.2 3.2 7.13989 3.2 12C3.2 16.8601 7.13989 20.8 12 20.8ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				fill="#4C4C58"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 20.8C16.8601 20.8 20.8 16.8601 20.8 12C20.8 7.13989 16.8601 3.2 12 3.2C7.13989 3.2 3.2 7.13989 3.2 12C3.2 16.8601 7.13989 20.8 12 20.8ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				fill="#4C4C58"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.8515 9.0738C13.6345 8.13228 12.7455 7.50353 11.7855 7.61262C10.8255 7.72171 10.1002 8.53391 10.1 9.50011C10.0999 9.83148 9.83126 10.1001 9.49989 10.1C9.16851 10.0999 8.89994 9.83125 8.9 9.49988C8.9003 7.92345 10.0836 6.59829 11.65 6.42029C13.2163 6.2423 14.6668 7.26816 15.0208 8.80432C15.3748 10.3405 14.5196 11.8977 13.0333 12.4232C12.7735 12.515 12.5999 12.7608 12.6 13.0363V13.875C12.6 14.2064 12.3314 14.475 12 14.475C11.6686 14.475 11.4 14.2064 11.4 13.875V13.037C11.3997 12.2527 11.8939 11.5532 12.6333 11.2918C13.5443 10.9697 14.0684 10.0153 13.8515 9.0738Z"
				fill="#4C4C58"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.0875 16.6875C11.0875 16.1835 11.496 15.775 12 15.775C12.504 15.775 12.9125 16.1835 12.9125 16.6875C12.9125 17.1915 12.504 17.6 12 17.6C11.496 17.6 11.0875 17.1915 11.0875 16.6875Z"
				fill="#4C4C58"
			/>
		</svg>
	</BaseIcon>
);

HelpIcon.propTypes = iconPropTypes;
HelpIcon.defaultProps = iconDefaultProps;
